/**
 * צופר - צבע אדום (Tzofar - Red Alert) — Israeli rocket-alert notifier
 *
 * Its single web-accessible-resource entry lists `logo.png` and `alert.html`, matched
 * to `<all_urls>` with no `use_dynamic_url`. `logo.png` is declared but not shipped in
 * this build, so `alert.html` is the one reachable resource — static and fetchable from
 * any page at a fixed URL, served only when the extension is installed.
 *
 * Manifest verified against version 1.2.6.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'hpbdhanjafnpeeobgejmdaajkiamfdpi';

export const tzofar: ExtensionDefinition = {
  id: ID,
  name: 'צופר - צבע אדום',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 20_000,
  notes:
    'Two WAR declared on every origin, but only alert.html ships (logo.png is absent). ' +
    'A single fetch of alert.html is conclusive.',
  signals: [
    {
      id: 'war-alert-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch alert.html — the alert overlay page, exposed to every origin with no ' +
        'dynamic URL and served only when the extension is installed.',
      weight: 1,
      run: () => probeFetch(ID, 'alert.html'),
    },
  ],
};
